interface IProduct {
  href: string;
  title: string;
  description: string;
  icon?: string;
}

export const productList: Array<IProduct> = [
  {
    href: 'https://www.bridgeline.com',
    title: 'Bridgeline',
    description: 'Corporate',
    icon: 'bridgeline'
  },
  {
    href: 'https://www.hawksearch.com',
    title: 'Hawksearch',
    description: 'Site Search',
    icon: 'hawksearch'
  },
  {
    href: 'https://www.woorank.com',
    title: 'WooRank',
    description: 'SEO',
    icon: 'woorank'
  },
  {
    href: 'https://e360.bridgeline.com/home',
    title: 'eCommerce 360',
    description: 'Dashboard',
    icon: 'e360'
  },
  {
    href: 'https://www.celebros.com',
    title: 'Celebros',
    description: 'Site Search',
    icon: 'celebros'
  },
  {
    href: 'https://www.orchestracms.com',
    title: 'OrchestraCMS',
    description: 'CMS',
    icon: 'orchestracms'
  },
  {
    href: 'https://www.trupresence.com',
    title: 'TruPresence',
    description: 'Franchise',
    icon: 'trupresence'
  },
  {
    href: 'https://www.experienceunbound.com/',
    title: 'Unbound',
    description: 'Digital Marketing',
    icon: 'unbound'
  },
  {
    href: 'https://www.databravo.com',
    title: 'Databravo',
    description: 'Data Enrichment',
    icon: 'databravo'
  }
];

export const partnersList: Array<IProduct> = [
  {
    href: 'https://accessibe.com/',
    title: 'AccessiBe',
    description: 'Accessibility',
    icon: 'accessibe'
  },
  {
    href: 'https://www.duda.co/',
    title: 'Duda',
    description: 'Website builder',
    icon: 'duda'
  }
];
